var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5259_40796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.584 0 0 3.584 0 8C0 12.416 3.584 16 8 16C12.416 16 16 12.416 16 8C16 3.584 12.416 0 8 0ZM8 12.8C7.41333 12.8 6.93333 12.32 6.93333 11.7333C6.93333 11.1467 7.41333 10.6667 8 10.6667C8.58667 10.6667 9.06667 11.1467 9.06667 11.7333C9.06667 12.32 8.58667 12.8 8 12.8ZM9.22133 4.528L8.864 8.80533C8.82667 9.25333 8.45333 9.6 8 9.6C7.54667 9.6 7.17333 9.25333 7.136 8.80533L6.77867 4.528C6.72 3.81333 7.28 3.2 8 3.2C8.68267 3.2 9.22667 3.75467 9.22667 4.42667C9.22667 4.45867 9.22667 4.496 9.22133 4.528Z",
    fill: "#BF3B3B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5259_40796"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.44b562ead44bf54d8fe485c1cfe90111.svg";
export { ForwardRef as ReactComponent };